export const RESELLER_PLANS = [
  'custom_partner_essentials',
  'custom_partner_premium',
  'trial_partner',
];

export const MAX_AGENTS_FOR_STARTER_PLAN = 2;
